import { useEffect, useState } from "react";
import Login from "../login/Login";
import getUrl from '../../../getUrl';
import sign from '../../../sign';
import { useSearchParams } from 'react-router-dom';
import apiCall from '../../../apiCall';
import './Demo.scss';
import ZkonImg from "../../../assets/img/Zkon.svg";

function Demo() {
  const [appName, setAppName] = useState("ZKON");
  const [urlOK, setUrlOK] = useState(getUrl() + "/account/demo");
  const [urlKO, setUrlKO] = useState(getUrl() + "/account/demo/ko");
  const [logoURI, setLogoUri] = useState("https://i.imgur.com/AdY3bvK.png");
  const [permissions, setPermissions] = useState(["READ", "WRITE"]);
  const [apps, setApps] = useState(["BINANCE"]);
  const [userId, setUserId] = useState(42);
  const [signature, setSignature] = useState(null);
  const [timestamp, setTimestamp] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [balances, setBalances] = useState(null);

  const [searchParams] = useSearchParams();
  useEffect(() => {
    console.log(searchParams.get('key'));
    console.log(searchParams.get('apiKey'));
    if (searchParams.get('apiKey') && searchParams.get('key') && !isLoading && balances == null) {
        setIsLoading(true);
        apiCall(searchParams.get('apiKey'), searchParams.get('key')).then((res) => {
          setBalances(res);
        }).finally(() => {
          setIsLoading(false);
        });
    }
  }, [searchParams, isLoading, balances]);

  useEffect(() => {
    const now = (new Date()).getTime();
    sign('Auth with zkon - ' + now, process.env.REACT_APP_PRIVATE_KEY).then((signature) => {
      setSignature(signature);
      setTimestamp(now);
    });
  }, []);

  const changePermissions = (permission) => {
    const index = permissions.indexOf(permission.target.value);
    if (index !== -1) {
      permissions.splice(index, 1);
      setPermissions([...permissions]);
    } else {
      setPermissions([...permissions, permission.target.value]);
    }
  };

  const changeApps = (app) => {
    const index = apps.indexOf(app.target.value);
    if (index !== -1) {
      apps.splice(index, 1);
      setApps([...apps]);
    } else {
      setApps([...apps, app.target.value]);
    }
  };

  return (
    <>
      <nav className="navbar">
        <div className="container">
          <a className="navbar-brand" href="#">
            <img src={ZkonImg} style={{ height: "35px" }} alt="ZKON Logo" />
          </a>
        </div>
      </nav>

      {isLoading && <div className='container'>
        <div className="row response-box"><h4>Loadind binance api...</h4></div>
      </div>}
      {balances && <div className='container'>
        <div className="row response-box">
          <div className="col-12">
            <p><strong>Binance BTC Balance</strong> {balances.btc} BTC</p>
            <p><strong>Binance USDT Balance</strong> {balances.usdt} USDT</p>
          </div>
        </div>
      </div>
      }
      <div className="container p-0 border-container">
        <div className="row">
          <div className="col-5 p-options overflow-y">
            <div className="row">
              <div className="col-12 mt-4">
                <h3>Options</h3>
                <br />
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    Add your company name
                  </label>
                  <input
                    id="name"
                    type="text"
                    className="form-control"
                    value={appName}
                    onChange={(e) => setAppName(e.target.value)}
                  ></input>
                  <div id="nameHelp" className="form-text">
                    The name of your application.
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="logo" className="form-label">
                    Add your company logo
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="logo"
                    value={logoURI}
                    onChange={(e) => setLogoUri(e.target.value)}
                  ></input>
                  <div id="logoHelp" className="form-text">
                    URL to the application's logo.
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="userId" className="form-label">
                    User Id
                  </label>
                  <input
                    id="userId"
                    type="number"
                    className="form-control"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                  ></input>
                  <div id="userIdHelp" className="form-text">
                    The user identifier on your platform
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="signature" className="form-label">
                    Signature
                  </label>
                  <input
                    id="signature"
                    type="text"
                    className="form-control"
                    value={signature || ""}
                    disabled={true}
                    onChange={() => {}}
                  ></input>
                  <div id="signatureHelp" className="form-text">
                    Obtained by signing 'Auth with zkon - [timestamp]' with your
                    client private key.
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="timestamp" className="form-label">
                    Timestamp
                  </label>
                  <input
                    id="timestamp"
                    type="text"
                    className="form-control"
                    value={timestamp || 0}
                    onChange={() => {}}
                    disabled={true}
                  ></input>
                  <div id="timestampHelp" className="form-text">
                    Timestamp used for the signature
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="urlOK" className="form-label">
                    Redirect URL OK
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="urlOK"
                    value={urlOK}
                    onChange={(e) => setUrlOK(e.target.value)}
                  ></input>
                  <div id="urlOKHelp" className="form-text">
                    URL to redirect after successfully obtaining secret shards,
                    which are parts of the encrypted data used in our secure
                    authentication process.
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="urlKO" className="form-label">
                    Redirect URL KO
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="urlKO"
                    value={urlKO}
                    onChange={(e) => setUrlKO(e.target.value)}
                  ></input>
                  <div id="urlKOHelp" className="form-text">
                    URL to redirect when we fail to obtain the secret shards.
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="permissions" className="form-label">
                    Permissions
                  </label>
                  <br />
                  <div onChange={changePermissions.bind(this)}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        id="read"
                        type="checkbox"
                        value="READ"
                        defaultChecked
                        name="Read"
                      />
                      <label className="form-check-label" htmlFor="read">
                        Read
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        id="write"
                        type="checkbox"
                        value="WRITE"
                        name="Write"
                        defaultChecked
                      />
                      <label className="form-check-label" htmlFor="write">
                        Write
                      </label>
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="permissions" className="form-label">
                    Applications
                  </label>
                  <div onChange={changeApps.bind(this)}>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="binance"
                        value="BINANCE"
                        defaultChecked
                        name="Binance"
                      />
                      <label className="form-check-label" htmlFor="binance">
                        Binance
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        id="kucoin"
                        type="checkbox"
                        value="KUCOIN"
                        name="Write"
                      />
                      <label className="form-check-label" htmlFor="kucoin">
                        Kucoin
                      </label>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="permissions" className="form-label">
                    Optional: Select verified data points
                  </label>
                  <div>
                  <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="tv"
                        value="Asset Balance"
                        name="Asset Balance"
                        checked={true}
                      />
                      <label className="form-check-label" htmlFor="tv">
                        Asset Balance
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="tv"
                        value="Trading Volume"
                        name="Trading Volume"
                      />
                      <label className="form-check-label" htmlFor="tv">
                        Trading Volume (Coming soon)
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="pnl"
                        value="pnl"
                        name="PnL"
                      />
                      <label className="form-check-label" htmlFor="pnl">
                        PnL (Coming soon)
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="pnl"
                        value="pnl"
                        name="PnL"
                      />
                      <label className="form-check-label" htmlFor="pnl">
                        Data Source verification (Coming soon)
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="pnl"
                        value="pnl"
                        name="PnL"
                      />
                      <label className="form-check-label" htmlFor="pnl">
                        Asset Price (coming soon)
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 mt-4">
                <h3>Embed Code</h3>
                <br />
                <label htmlFor="embed" className="form-label">
                  HTML
                </label>
                <textarea
                  className="form-control"
                  id="embed"
                  rows={7}
                  onChange={() => {}}
                  value={
                    '<iframe src="' +
                    getUrl() +
                    "/account/login/" +
                    appName +
                    "/" +
                    permissions.join(",") +
                    "/" +
                    apps.join(",") +
                    "/" +
                    encodeURIComponent(urlKO) +
                    "/" +
                    encodeURIComponent(urlKO) +
                    "/" +
                    encodeURIComponent(logoURI) +
                    "/" +
                    userId +
                    "/" +
                    encodeURIComponent(signature) +
                    "/" +
                    timestamp +
                    '"></iframe>'
                  }
                ></textarea>
              </div>
            </div>
          </div>
          <div className="col-7">
            <div className="bck-black">
              <Login
                appName={appName}
                permissions={permissions}
                apps={apps}
                redirectOK={urlOK}
                redirectKO={urlKO}
                logoURI={logoURI}
                userId={userId}
                signature={signature}
                timestamp={timestamp}
              ></Login>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Demo;
